module.exports = __webpack_public_path__ + "media/vue/assets/images/booking-service/beauty-classes-de5bdd4547ec5a0bbb245da1031c05b1.jpg";